<template>
    <div
        class="fa m-1 text-bigger"
        :class="checked ? 'fa-check-square-o text-success' : 'fa-square-o'"
    ></div>
</template>

<script>
export default {
    props: {
        map: { type: Object, required: true },
        questions: { type: Array, required: true },
        label: { type: String },
    },
    created() {
        this.$emit('change', this.checked, this.label);
    },
    computed: {
        currentAnswers() {
            return this.questions
                .filter((item) => !!item.data.return_value)
                .map((item) => item.data.return_value);
        },
        neededAnswersForChecked() {
            let arr = [];

            Object.keys(this.map).forEach((questionText) => {
                if (this.map[questionText] instanceof Array) {
                    arr = arr.concat(this.map[questionText]);
                } else {
                    arr.push(this.map[questionText]);
                }
            });

            return arr;
        },
        checked() {
            const answers = this.currentAnswers.map((item) => item.toLowerCase().trim());
            const needAnswers = this.neededAnswersForChecked.map((item) =>
                item.toLowerCase().trim()
            );

            return needAnswers.some((ans) => answers.indexOf(ans) >= 0);
        },
    },
    watch: {
        checked(value) {
            this.$emit('change', value, this.label);
        },
    },
};
</script>
